import React, { useState } from 'react';
import axios from 'axios';

const SABLONLAR = [
  { key: 'teklif', label: 'İş Teklifi Şablonu', aciklama: 'Adaylara gönderilecek iş teklifi mektubu', dosyaAdi: 'teklif_sablonu.docx' },
  { key: 'sozlesme', label: 'İş Sözleşmesi Şablonu', aciklama: 'Kabul edilen adaylara gönderilecek sözleşme', dosyaAdi: 'sozlesme.docx' },
  { key: 'calisma_izin', label: 'Çalışma ve İzin Yazısı Şablonu', aciklama: 'Vize başvurusu için çalışma yazısı', dosyaAdi: 'Calisma_Izin_Yazisi_Sablonu.docx' },
];

const SablonYonetimiPage = () => {
  const [seciliDosyalar, setSeciliDosyalar] = useState({});
  const [sonuclar, setSonuclar] = useState({});
  const [yukleniyor, setYukleniyor] = useState({});

  const handleDosyaSec = (key, dosya) => {
    setSeciliDosyalar(p => ({ ...p, [key]: dosya }));
  };

  const handleYukle = async (sablon) => {
    const dosya = seciliDosyalar[sablon.key];
    if (!dosya) { setSonuclar(p => ({ ...p, [sablon.key]: { tip: 'hata', mesaj: 'Dosya seçin.' } })); return; }
    setYukleniyor(p => ({ ...p, [sablon.key]: true }));
    setSonuclar(p => ({ ...p, [sablon.key]: null }));
    const fd = new FormData();
    fd.append('sablon', dosya);
    fd.append('tur', sablon.key);
    try {
      await axios.post('/api/admin/sablon/' + sablon.key, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSonuclar(p => ({ ...p, [sablon.key]: { tip: 'basari', mesaj: sablon.label + ' güncellendi!' } }));
      setSeciliDosyalar(p => ({ ...p, [sablon.key]: null }));
    } catch(err) {
      setSonuclar(p => ({ ...p, [sablon.key]: { tip: 'hata', mesaj: err.response?.data?.hata || 'Yükleme başarısız.' } }));
    } finally {
      setYukleniyor(p => ({ ...p, [sablon.key]: false }));
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Sözleşme ve Form Şablonları</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>İş teklifi, sözleşme ve diğer şablonları güncelleyin. DOCX ve PDF formatları kabul edilir.</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {SABLONLAR.map(sablon => {
          const sonuc = sonuclar[sablon.key];
          const yukleniyor_ = yukleniyor[sablon.key];
          const secili = seciliDosyalar[sablon.key];
          return (
            <div key={sablon.key} className="card">
              <div className="card-header">
                <h2>{sablon.label}</h2>
                <p>{sablon.aciklama}</p>
              </div>
              {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}
              <label className="dosya-alan" htmlFor={'sablon-' + sablon.key}>
                <input id={'sablon-' + sablon.key} type="file" accept=".docx,.pdf" onChange={e => handleDosyaSec(sablon.key, e.target.files[0])} style={{ display: 'none' }} />
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--gri-400)" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}>
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
                </svg>
                <p>DOCX veya PDF dosyası seçmek için tıklayın</p>
                {secili && <div style={{ fontSize: '13px', color: 'var(--yesil)', fontWeight: '500', marginTop: '8px' }}>✓ {secili.name}</div>}
              </label>
              <button className="btn btn-primary" disabled={!secili || yukleniyor_} onClick={() => handleYukle(sablon)} style={{ marginTop: '1rem' }}>
                {yukleniyor_ ? 'Yükleniyor...' : sablon.label + ' Güncelle'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SablonYonetimiPage;
